import React, { useCallback } from "react"
import { Button } from "react-bootstrap"

/**
 * 10キーのキーパッドを提供します
 *
 * @param {*} props
 * @return {*}
 */
const NumberKeyPad: React.FC<{
  value: string | undefined
  setValue: (value: string | undefined) => unknown
}> = React.memo((props) => {
  const onTouchStartEventHandler = useCallback(
    (e: React.TouchEvent<HTMLButtonElement>) => {
      e.stopPropagation()
      e.preventDefault()

      const value = e.currentTarget.value
      switch (value) {
        case "消":
          if (props.value == null) return
          props.setValue(props.value.slice(0, -1))
          break
        case "":
          break
        default:
          props.setValue(props.value == null ? value : props.value + value)
          break
      }
      navigator.vibrate(100)
    },
    [props]
  )

  return (
    <>
      <table>
        <tbody>
          {[
            ["1", "2", "3"],
            ["4", "5", "6"],
            ["7", "8", "9"],
            ["", "0", "消"],
          ].map((row, i) => (
            <tr key={i}>
              {row.map((value) => (
                <td key={`${i}_${value}`}>
                  {value !== "" && (
                    <Button
                      style={{
                        fontSize: "4rem",
                        fontWeight: "bold",
                        width: "8rem",
                        height: "calc(100% - 5rem)",
                        margin: "0.5rem",
                        border: "2px solid #5f5f5f5f",
                      }}
                      variant="light"
                      onTouchStart={onTouchStartEventHandler}
                      value={value}>
                      {value}
                    </Button>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
})

export default NumberKeyPad
